import React, { useState } from 'react';
import { ModalLegal } from './';

export default function Footer() {
  const [openLegal, setOpenLegal] = useState(false);
  const toggleLegal = (state: boolean) => (_: any) => setOpenLegal(state);

  return (
    <>
      <div className="container-fluid bg-white pt30 pb30 mb40">
        <div className="container">
          <div className="row mb30">
            <div className="col-12 text-center">
              <h3 className="px-16 mb20">Seguro operado por Chubb Seguros Mexico S.A.</h3>
              <img
                src="//sfestaticos.blob.core.windows.net/guideline/companies/chubb-filled.svg"
                alt="Compañia Metlife"
                width="140px"
              />
            </div>
          </div>
        </div>
      </div>
      <ModalLegal open={openLegal} toggle={toggleLegal} />
    </>
  );
}
